export default function isJsalBday() {
    const today = new Date();
    const month = today.getMonth(); // 0-11
    const day = today.getDate() // 1-31

    const isNov7th = month === 10 && (day === 6 || day === 7); // They day before because the 7th is a saturday

    console.log(`Today is${isNov7th ? '' : ' not'} James' birthday.`)

    return isNov7th;
}